export default __webpack_public_path__ + "static/mens-c9dc55dde749d2a8fa3dbc20fd6db247.webp";